define('display/layers/vector/styles/definitions',[], function() {
    var colorMap = {
        'background': '#EEF6EC',
        'building': '#dddddd',
        'builtUpArea': '#FFDFB5',
        'townBlock': '#A4D1B0',
        'park': '#A4C8A8',
        'zoo': '#ADD6B9',
        'nationalPark': '#A4C8A8',
        'regionalPark': '#A4D2B1',
        'statePark': '#A4D2B1',
        'woodland': '#C1DCC4',
        'industrial': '#d1d9e1',
        'industrialHarbor': '#EEF6EC',
        'stadium': '#c9d4b0',
        'hospital': '#F1EDC1',
        'shop': '#A9BAD4',
        'amusement': '#d7b0a9',
        'university': '#DDCBE4',
        'school': '#A9BAD5',
        'institution': '#A9BAD5',
        'parking': '#DCDCDC',
        'sportsHall': '#A9BAD4',
        'golf': '#C8E1A4',
        'runway': '#ffffff',
        'military': '#bcbcaa',
        'airport': '#e6dfce',
        'cemetery': '#AEBC95',
        'moor': '#E8D0D5',
        'beachDune': '#feecb6',
        'sand': '#feecb6',
        'forest': '#A4C8A8',
        'wadi': '#C0D2C4',
        'water': '#aed2ec',
        'lake': '#aed2ec',
        'oceanSea': '#B0D3EC',
        'cartographicLineState': '#B3A9BC',
        'cartographicLineCountry': '#876AA5',
        'buildingFactory': '#CBCCC8',
        'buildingWorship': '#DDBE7E',
        'buildingHospital': '#959591',
        'buildingHotel': '#EAA879',
        'buildingCulture': '#E0948D',
        'buildingRailwayStat': '#F0E1C4',
        'buildingSubwayStat': '#C0C0C0',
        'buildingOther': '#F5BC92',
        'buildingGovernment': '#C9D4B0',
        'blocksGardenPath': '#E8EEEF',
        'blocksSwimmingPool': '#AED2EC',
        'blocksPaved': '#EDC99E',
        'blocksPedestrianDeck': '#E8EDEE',
        'blocksWalkway': '#E8EDEE',
        'blockCarriagewayDivider': '#C0C0C0',
        'blocksFactoryGround': '#EEF6EC',
        'blocksSchoolGround': '#A9BAD4',
        'blocksHospitalGround': '#A9BAD4',
        'blocksRailwayGround': '#F0E5E3',
        'blocksGreen': '#A4D1B0',
        'blocksGrass': '#C6E3D2',
        'blocksWater': '#AED2EC',
        'meridian': '#F2F2F2',
        'sidewalk': '#F2F2F2',
        'breakwater': '#F2F2F2',
        'pool': '#AED2EC',
        'countryBorder': '#968AAC',
        'stateBorder': '#C1B9C9',
        'disputedCountryBorder': '#FF0000',

        'motorway1517': '#EFB19C',
        'motorway1214': '#EFB7A4',
        'motorway11': '#EFB19C',
        'motorway510': '#EFB7A4',
        'motorwayOutl': '#CE826A',

        'internationalRoad1617': '#D6CEAB',
        'internationalRoad15': '#D0C9A6',
        'internationalRoad14': '#D6CEAA',
        'internationalRoad1113': '#D0C57F',
        'internationalRoad10': '#D6CEAA',
        'internationalRoad9': '#FED9BC',
        'internationalRoad8': '#FFF4DB',
        'internationalRoad7': '#FED9BC',
        'internationalRoad56': '#EBCFB7',

        'internationalRoad1617Outl': '#A89B7C',
        'internationalRoad1415Outl': '#B09F7B',
        'internationalRoad1113Outl': '#B2A587',
        'internationalRoad710Outl': '#A89B7C',

        'majorRoad17': '#C9C3AC',
        'majorRoad16': '#E6D6AF',
        'majorRoad15': '#C9C3AC',
        'majorRoad14': '#CEC8A5',
        'majorRoad1013': '#D0C9A6',
        'majorRoad9': '#FED9BC',
        'majorRoad8': '#FFF4DB',

        'majorRoad17Outl': '#A5997A',
        'majorRoad16Outl': '#AB9E7F',
        'majorRoad15Outl': '#A5997A',
        'majorRoad1014Outl': '#B09F7B',
        'majorRoad89Outl': '#A89B7C',

        'secondaryRoad1617': '#D8CC99',
        'secondaryRoad15': '#DCD2AF',
        'secondaryRoad14': '#E5DAAF',
        'secondaryRoad1213': '#FDF8BF',
        'secondaryRoad11': '#FFFDEB',
        'secondaryRoad10': '#FFFEF2',

        'secondaryRoad1517Outl': '#AB9E7F',
        'secondaryRoad14Outl': '#B09F7B',
        'secondaryRoad1213Outl': '#CCC195',
        'secondaryRoad11Outl': '#A79A7C',
        'secondaryRoad10Outl': '#C8BC91',
        'secondaryRoad9Outl': '#D6CEAA',

        'connectingRoad1617': '#D8CC99',
        'connectingRoad15': '#E6D6AF',
        'connectingRoad14': '#E5DAAF',
        'connectingRoad13': '#FFFDF8',
        'connectingRoad12': '#FFFDF3',
        'connectingRoad11': '#FFFEF2',

        'connectingRoad1517Outl': '#AB9E7F',
        'connectingRoad14Outl': '#B09F7B',
        'connectingRoad1213Outl': '#C6BC93',
        'connectingRoad11Outl': '#C8BC91',
        'connectingRoad10Outl': '#D6CEAA',

        'majorLocalRoad17': '#FFFDEB',
        'majorLocalRoad16': '#EAE2C6',
        'majorLocalRoad15': '#FFFEEE',
        'majorLocalRoad1214': '#F7F7F9',
        'majorLocalRoad11': '#D6CEAA',

        'majorLocalRoad1617Outl': '#C8BC91',
        'majorLocalRoad1215Outl': '#ADABAC',

        'localRoad1617': '#FFFEEE',
        'localRoad15': '#FFFDED',
        'localRoad1314': '#D6CEAA',

        'localRoad1517Outl': '#C8BC91',
        'localRoad1114Outl': '#D6CEAA',

        'minorLocalRoad1617': '#FFFEEE',
        'minorLocalRoad15': '#FFFDED',
        'minorLocalRoad1314': '#D6CEAA',

        'minorLocalRoad1517Outl': '#C8BC91',
        'minorLocalRoad1114Outl': '#D6CEAA',

        'pedestrianRoad1617': '#E6E7E8',
        'pedestrianRoad1617Outl': '#c1c0c0',

        'walkwayRoad1617': '#E6E7E8',
        'walkwayRoad1617Outl': '#c1c0c0',

        'nonPublicRoad1114': '#D6CEAA',
        'nonPublicRoad1517': '#FFFEEE',
        'nonPublicRoad1517Outl': '#C8BC91',

        'tollRoads1518': '#EFB5F2',
        'tollRoads714': '#E2A9F3',

        'ferryStrokeColor': '#66A1C8',
        'railWayStrokeRound': '#FFFFFF',
        'railWayStrokeSquare': '#5081AE',

        'labelText': '#000000',
        'labelTextHalo': 'rgba(255,255,255,0.75)',

        'ferryLabelText': '#064168',
        'ferryLabelTextHalo': 'rgba(0xAE,0xD2,0xEC,0.75)',

        'nationalParksLabelText': '#719975',
        'nationalParksLabelHalo': 'rgba(0xDD,0xFF,0xE1,0.75)',

        'oceanLabelText': '#3C80AF',
        'oceanLabelHalo': '#D3E1F5',

        'countryLabelText': '#8B2121',
        'countryLabelHalo': '#EEF6EC',

        'cityLabelText': '#000000',
        'cityLabelHalo': '#EEF6EC',

        'stateLabelText': '#7E5119',
        'stateLabelHalo': '#EEF6EC',

        'airportLabelText': '#BF8FC1',
        'airportLabelHalo': '#F6EDDB',

        'railwayStationLabelText': '#6D739D',
        'railwayStationLabelHalo': '#F6EDDB',

        //range 1 - 84
        'firstIconText': '#FFFFFF',
        'firstIconTextHalo': '#FFFFFF',

        //range 85+
        'secondIconText': '#000000',
        'secondIconTextHalo': '#FFFFFF'
    };

    var iconRange = 92;

    var roadsWidthStops = {
        'motorwayToll': [[4, 1.0], [5, 1.0], [6, 1.0], [7, 10.0], [8, 12.0], [10, 13.0], [11, 13.0], [12, 13.0],
                        [13, 14.0], [14, 20.0], [15, 24.0], [18, 30.0]],
        'motorwayOutl': [[4, 1.0], [5, 1.5], [6, 1.0], [7, 6.0], [8, 7.5], [9, 8.0], [10, 8.5], [11, 8.0], [12, 9.0],
                        [13, 10.0], [14, 13.0], [15, 16.0], [18, 22.0]],
        'motorway': [[4, 1.0], [5, 1.0], [6, 1.0], [7, 4.0], [8, 5.0], [10, 5.0], [11, 5.0], [12, 6.0],
                    [13, 7.0], [14, 10.0], [15, 12.0], [16, 14.5], [17, 18.0], [18, 20.0]],

        'internationalRoadToll': [[4, 1.0], [5, 1.0], [6, 1.0], [8, 8.0], [10, 9.0], [12, 10.0],
                                 [13, 9.0], [14, 12.0], [15, 16.0], [16, 25.0], [17, 35.0], [18, 35.0]],
        'internationalRoadOutl': [[4, 1.0], [5, 1.0], [6, 1.0], [8, 5.0], [10, 6.5], [12, 7.0],
                                 [13, 7.0], [14, 9.0], [15, 12.0], [16, 16.0], [17, 18.0], [18, 22.0]],
        'internationalRoad': [[4, 1.0], [5, 1.0], [6, 1.0], [8, 3.0], [10, 3.5], [12, 4.0],
                             [13, 5.0], [14, 6.0], [15, 11.0], [16, 15.0], [17, 17.0], [18, 19.0]],

        'majorRoadToll': [[4, 4.0], [5, 7.0], [6, 7.0], [7, 7.0], [8, 7.0], [10, 9.0], [11, 9.5], [12, 10.0],
                         [13, 13.0], [14, 14.0], [15, 23.0], [16, 25.0], [17, 35.0], [18, 35.0]],
        'majorRoadOutl': [[4, 2.0], [5, 5.0], [6, 5.0], [7, 5.0], [8, 5.0], [9, 6.0], [10, 6.0], [12, 6.0],
                         [13, 10.0], [14, 9.0], [15, 11.0], [16, 13.0], [17, 17.0], [18, 21.0]],
        'majorRoad': [[4, 1.0], [5, 1.0], [6, 1.0], [7, 3.0], [8, 3.0], [10, 3.5], [12, 4.0],
                     [13, 5.0], [14, 6.0], [15, 10.0], [16, 12.0], [17, 16.0], [18, 18.0]],

        'secondaryRoadToll': [[6, 2.0], [7, 2.0], [8, 2.0], [9, 3.0], [10, 5.0], [11, 7.0], [12, 7.5],
                             [13, 12.0], [14, 14.0], [15, 21.0], [16, 23.0], [17, 25.0], [18, 27.0]],
        'secondaryRoadOutl': [[6, 1.0], [7, 1.0], [8, 1.0], [9, 2.0], [10, 4.0], [11, 5.0], [12, 5.5],
                             [13, 9.0], [14, 10.0], [15, 16.0], [16, 18.0], [17, 20.0], [18, 22.0]],
        'secondaryRoad': [[6, 0.0], [7, 0.0], [8, 0.0], [9, 0.0], [10, 3.0], [11, 3.0], [12, 3.0],
                         [13, 6.0], [14, 7.0], [15, 11.0], [16, 13.0], [17, 15.0], [18, 17.0]],

        'connectingRoadToll': [[10, 1.5], [11, 2.5], [12, 6.0], [13, 6.5], [14, 10.0], [15, 14.0], [16, 20.0],
                                [17, 25.0], [18, 26.0]],
        'connectingRoadOutl': [[10, 0.0], [11, 1.5], [12, 4.0],
                                [13, 4.5], [14, 7.0], [15, 10.0], [16, 16.0], [17, 21.0], [18, 23.0]],
        'connectingRoad': [[10, 1.0], [11, 1.5], [12, 2.0],
                            [13, 2.5], [14, 4.0], [15, 6.0], [16, 10.0], [17, 14.0], [18, 16.0]],

        'majorLocalRoadToll': [[10, 1.5], [11, 2.5], [12, 6.0],
                              [13, 6.5], [14, 10.0], [15, 14.0], [16, 20.0], [17, 25.0], [18, 26.0]],
        'majorLocalRoadOutl': [[10, 0.0], [11, 1.5], [12, 4.0],
                              [13, 4.5], [14, 7.0], [15, 10.0], [16, 16.0], [17, 21.0], [18, 23.0]],
        'majorLocalRoad': [[10, 1.0], [11, 1.5], [12, 2.0],
                          [13, 2.5], [14, 4.0], [15, 6.0], [16, 10.0], [17, 14.0], [18, 16.0]],

        'localRoadToll': [[10, 2.0], [13, 3.0], [14, 3.0], [15, 10.0], [16, 15.0], [17, 20.0], [18, 24.0]],
        'localRoadOutl': [[10, 1.0], [13, 2.0], [14, 2.0], [15, 7.0], [16, 12.0], [17, 17.0], [18, 21.0]],
        'localRoad': [[10, 1.0], [13, 2.0], [14, 2.0], [15, 4.0], [16, 9.0], [17, 13.0], [18, 15.0]],

        'minorLocalRoadToll': [[10, 2.0], [13, 3.0], [14, 3.0], [15, 10.0], [16, 14.0], [17, 18.0], [18, 22.0]],
        'minorLocalRoadOutl': [[10, 1.0], [13, 2.0], [14, 2.0], [15, 7.0], [16, 11.0], [17, 15.0], [18, 19.0]],
        'minorLocalRoad': [[10, 1.0], [13, 2.0], [14, 2.0], [15, 4.0], [16, 8.0], [17, 11.0], [18, 14.0]],

        'cartographicCountry': [[0, 1.0], [1, 1.0], [2, 1.0], [3, 1.0], [4, 1.0], [5, 1.0], [6, 1.0], [8, 2.0],
                               [18, 2.0]],
        'cartographicState': [[0, 1.0], [1, 1.0], [2, 1.0], [3, 1.0], [4, 1.0], [5, 1.0], [6, 1.0], [7, 1.0], [8, 2.0],
                             [18, 2.0]],
        'cartographicWater': [[0, 1.0], [1, 1.0], [2, 1.0], [3, 1.0], [4, 1.0], [5, 1.0], [6, 1.0], [7, 1.0], [8, 2.0],
                             [18, 2.0]],
        'railOutl': [[4, 0.8], [8, 1.4], [12, 1.4], [15, 2.3], [18, 5.0]],
        'rail': [[4, 0.6], [8, 1.0], [12, 1.0], [15, 1.7], [18, 3.5]],

        'ferry': [[0, 1.0], [1, 1.0], [2, 1.0], [3, 1.0], [4, 1.0], [5, 1.0], [6, 1.0], [7, 1.0], [8, 1.0], [9, 1.0],
                 [10, 1.0], [11, 1.0], [12, 1.0], [13, 1.0], [14, 1.0], [15, 1.0], [16, 1.0], [17, 1.0], [18, 1.0]]
    };

    var padding = {
        'icon': 5,
        'country': 10,
        'state': 10,
        'capitalCity': 10,
        'largeCity': 10,
        'mediumCity': 10,
        'smallCity': 10,
        'town': 10,
        'village': 10
    };

    var labelTextStops = {
        'country': [[0, 10], [4, 12], [5, 13], [6, 15], [7, 18], [8, 22]],
        'state': [[0, 10], [4, 11], [5, 12], [7, 14], [8, 16]],
        'capitalCity': [[0, 8], [4, 11], [9, 20], [10, 21], [11, 23], [12, 25], [15, 27]],
        'largeCity': [[0, 8], [5, 12], [7, 14], [8, 16], [9, 18], [10, 19], [11, 21], [12, 23], [15, 25]],
        'mediumCity': [[0, 7], [5, 11], [7, 12], [8, 13], [9, 15], [10, 17], [11, 19], [12, 21], [15, 23]],
        'smallCity': [[0, 6], [7, 11], [8, 12], [9, 13], [10, 15], [11, 17], [12, 19], [15, 21]],
        'town': [[0, 6], [7, 11], [8, 12], [9, 13], [10, 14], [11, 16], [12, 18], [13, 20], [15, 22]],
        'village': [[0, 5], [7, 11], [9, 12], [10, 13], [11, 15], [12, 17], [13, 19], [15, 21]],

        'ocean': [[0, 11], [3, 13], [4, 17], [5, 20]],
        'park': [[0, 8], [12, 13], [14, 14], [15, 15], [16, 16], [17, 18]],
        'rail': [[0, 8], [13, 12], [14, 13], [15, 14], [16, 15]],

        'motorway': [[0, 8], [10, 12], [13, 13], [14, 14], [15, 15]],
        'internationalRoad': [[0, 8], [10, 12], [13, 13], [14, 14], [15, 15]],
        'majorRoad': [[0, 8], [10, 12], [13, 13], [14, 14], [15, 15]],
        'secondaryRoad': [[0, 8], [10, 12], [14, 13], [15, 14]],
        'connectingRoad': [[0, 8], [10, 12], [15, 13]],
        'majorLocalRoad': [[0, 8], [10, 12], [17, 13]],
        'localRoad': [[0, 8], [12, 12]],
        'minorLocalRoad': [[0, 8], [12, 12]],

        'ferry': [[14, 12]],
        'icon': [[0, 11], [10, 11], [20, 11]],
        'airport': [[0, 8], [12, 11], [13, 12], [14, 13], [15, 14], [16, 15]]
    };

    var labelTextHalo = {
        'nationalPark': [[0, 1], [16, 1.5], [17, 2.0]],
        'motorway': [[0, 1], [16, 1.5], [17, 2.0]],
        'internationalRoad': [[0, 1], [16, 1.5], [17, 2.0]],
        'majorRoad': [[0, 1], [16, 1.5], [17, 2.0]],
        'secondaryRoad': [[0, 1], [16, 1.5], [17, 2.0]],
        'connectingRoad': [[0, 1], [16, 1.5], [17, 2.0]]
    };

    var nightColorMap = {
        'background': '#363636',
        'building': '#2a2a2a',
        'builtUpArea': '#262626',
        'townBlock': '#424242',
        'park': '#494949',
        'zoo': '#3c3c3c',
        'nationalPark': '#494949',
        'regionalPark': '#414141',
        'statePark': '#414141',
        'woodland': '#333333',
        'industrial': '#313131',
        'industrialHarbor': '#141414',
        'stadium': '#383838',
        'hospital': '#1d1d1d',
        'shop': '#1a1a1a',
        'amusement': '#505050',
        'university': '#373737',
        'school': '#4f4f4f',
        'institution': '#191919',
        'parking': '#292929',
        'sportsHall': '#262626',
        'golf': '#303030',
        'runway': '#151515',
        'military': '#4c4c4c',
        'airport': '#292929',
        'cemetery': '#515151',
        'moor': '#323232',
        'beachDune': '#1b1b1b',
        'sand': '#1b1b1b',
        'forest': '#494949',
        'wadi': '#282828',
        'water': '#111111',
        'lake': '#111111',
        'oceanSea': '#111111',
        'cartographicLineState': '#5b5b5b',
        'cartographicLineCountry': '#939393',
        'buildingFactory': '#414141',
        'buildingWorship': '#474747',
        'buildingHospital': '#737373',
        'buildingHotel': '#4C4C4C',
        'buildingCulture': '#424242',
        'buildingRailwayStat': '#252525',
        'buildingSubwayStat': '#464646',
        'buildingOther': '#424242',
        'buildingGovernment': '#C9D4B0',
        'blocksGardenPath': '#1b1b1b',
        'blocksSwimmingPool': '#111111',
        'blocksPaved': '#444444',
        'blocksPedestrianDeck': '#1A1A1A',
        'blocksWalkway': '#1A1A1A',
        'blockCarriagewayDivider': '#474747',
        'blocksFactoryGround': '#141414',
        'blocksSchoolGround': '#1a1a1a',
        'blocksHospitalGround': '#1a1a1a',
        'blocksRailwayGround': '#202020',
        'blocksGreen': '#424242',
        'blocksGrass': '#2A2A2A',
        'blocksWater': '#111111',
        'meridian': '#161616',
        'sidewalk': '#161616',
        'breakwater': '#161616',
        'pool': '#111111',
        'countryBorder': '#939393',
        'stateBorder': '#5b5b5b',
        'disputedCountryBorder': '#282727',

        'motorway1517': '#3c3c3c',
        'motorway1214': '#414141',
        'motorway11': '#3c3c3c',
        'motorway510': '#414141',
        'motorwayOutl': '#101010',

        'internationalRoad1617': '#4d4d4d',
        'internationalRoad15': '#484848',
        'internationalRoad14': '#4d4d4d',
        'internationalRoad1113': '#424242',
        'internationalRoad10': '#4d4d4d',
        'internationalRoad9': '#5e5e5e',
        'internationalRoad8': '#747474',
        'internationalRoad7': '#5e5e5e',
        'internationalRoad56': '#535353',

        'internationalRoad1617Outl': '#1b1b1b',
        'internationalRoad1415Outl': '#202020',
        'internationalRoad1113Outl': '#252525',
        'internationalRoad710Outl': '#1b1b1b',

        'majorRoad17': '#424242',
        'majorRoad16': '#565656',
        'majorRoad15': '#424242',
        'majorRoad14': '#464646',
        'majorRoad1013': '#484848',
        'majorRoad9': '#5e5e5e',
        'majorRoad8': '#747474',

        'majorRoad17Outl': '#191919',
        'majorRoad16Outl': '#1e1e1e',
        'majorRoad15Outl': '#191919',
        'majorRoad1014Outl': '#202020',
        'majorRoad89Outl': '#1b1b1b',

        'secondaryRoad1617': '#4a4a4a',
        'secondaryRoad15': '#515151',
        'secondaryRoad14': '#595959',
        'secondaryRoad1213': '#767676',
        'secondaryRoad11': '#7c7c7c',
        'secondaryRoad10': '#7d7d7d',

        'secondaryRoad1517Outl': '#1e1e1e',
        'secondaryRoad14Outl': '#202020',
        'secondaryRoad1213Outl': '#404040',
        'secondaryRoad11Outl': '#1a1a1a',
        'secondaryRoad10Outl': '#3b3b3b',
        'secondaryRoad9Outl': '#4d4d4d',

        'connectingRoad1617': '#4a4a4a',
        'connectingRoad15': '#565656',
        'connectingRoad14': '#595959',
        'connectingRoad13': '#7d7d7d',
        'connectingRoad12': '#7c7c7c',
        'connectingRoad11': '#7d7d7d',

        'connectingRoad1517Outl': '#1e1e1e',
        'connectingRoad14Outl': '#202020',
        'connectingRoad1213Outl': '#3b3b3b',
        'connectingRoad11Outl': '#3b3b3b',
        'connectingRoad10Outl': '#4d4d4d',

        'majorLocalRoad17': '#7c7c7c',
        'majorLocalRoad16': '#616161',
        'majorLocalRoad15': '#7d7d7d',
        'majorLocalRoad1214': '#777777',
        'majorLocalRoad11': '#4d4d4d',

        'majorLocalRoad1617Outl': '#3b3b3b',
        'majorLocalRoad1215Outl': '#2b2b2b',

        'localRoad1617': '#7d7d7d',
        'localRoad15': '#7c7c7c',
        'localRoad1314': '#4d4d4d',

        'localRoad1517Outl': '#3b3b3b',
        'localRoad1114Outl': '#4d4d4d',

        'minorLocalRoad1617': '#7d7d7d',
        'minorLocalRoad15': '#7c7c7c',
        'minorLocalRoad1314': '#4d4d4d',

        'minorLocalRoad1517Outl': '#3b3b3b',
        'minorLocalRoad1114Outl': '#4d4d4d',

        'pedestrianRoad1617': '#666666',
        'pedestrianRoad1617Outl': '#404040',

        'walkwayRoad1617': '#666666',
        'walkwayRoad1617Outl': '#404040',

        'nonPublicRoad1114': '#4d4d4d',
        'nonPublicRoad1517': '#7d7d7d',
        'nonPublicRoad1517Outl': '#3b3b3b',

        'tollRoads1518': '#454545',
        'tollRoads714': '#3a3a3a',

        'ferryStrokeColor': '#171717',
        'railWayStrokeRound': '#7e7e7e',
        'railWayStrokeSquare': '#070707',

        'labelText': '#FFFFFF',
        'labelTextHalo': '#191919',

        'ferryLabelText': '#d0d0d0',
        'ferryLabelTextHalo': '#3b3b3b',

        'nationalParksLabelText': '#797979',
        'nationalParksLabelHalo': '#121212',

        'oceanLabelText': '#929292',
        'oceanLabelHalo': '#282828',

        'countryLabelText': '#d0d0d0',
        'countryLabelHalo': '#141414',

        'cityLabelText': '#cccccc',
        'cityLabelHalo': '#141414',

        'stateLabelText': '#b1b1b1',
        'stateLabelHalo': '#141414',

        'airportLabelText': '#6b6b6b',
        'airportLabelHalo': '#1a1a1a',

        'railwayStationLabelText': '#939393',
        'railwayStationLabelHalo': '#1a1a1a',

        //range 1 - 84
        'firstIconText': '#ffffff',
        'firstIconTextHalo': '#ffffff',

        //range 85+
        'secondIconText': '#000000',
        'secondIconTextHalo': '#ffffff'
    };

    return {
        colorMap: colorMap,
        iconRange: iconRange,
        roadsWidthStops: roadsWidthStops,
        padding: padding,
        labelTextStops: labelTextStops,
        labelTextHalo: labelTextHalo,
        nightColorMap: nightColorMap
    };
});

